import { useState } from 'react'
import { useNav } from '../nav/NavContext.js'
import { MasterScreen, type MasterScreenConfig } from '../masters/MasterScreen.js'
import {
  brokersConfig,
  customersConfig,
  driversConfig,
  vehiclesConfig,
  vendorsConfig,
} from '../masters/configs.js'

const TABS: Array<{ key: string; label: string; config: MasterScreenConfig }> = [
  { key: 'customers', label: 'Customers', config: customersConfig },
  { key: 'vehicles', label: 'Vehicles', config: vehiclesConfig },
  { key: 'drivers', label: 'Drivers', config: driversConfig },
  { key: 'brokers', label: 'Brokers', config: brokersConfig },
  { key: 'vendors', label: 'Vendors', config: vendorsConfig },
]

/**
 * Stage 3 §5: one screen pattern, five day-to-day masters (the admin masters live in Settings, Stage 12 §3). Each tab remounts MasterScreen
 * (via `key`) rather than sharing one instance across configs, so per-master
 * list/search/pagination state and any loadOptions() calls start fresh.
 */
export function MastersPage() {
  const { params } = useNav()
  const [active, setActive] = useState(TABS.some((t) => t.key === params.tab) ? params.tab! : TABS[0]!.key)
  const activeTab = TABS.find((t) => t.key === active)!

  return (
    <div>
      <nav className="tf-tabs">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            type="button"
            className={tab.key === active ? 'tf-tab-active' : ''}
            onClick={() => setActive(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </nav>
      <MasterScreen key={activeTab.key} config={activeTab.config} />
    </div>
  )
}
